import React, { useState } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Form, Label, Loader, Statistic, Segment, InputProps } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import sectorProductivityRepository, { ISectorProductivityMonth, ISectorProductivityParams } from "../../Repositories/SectorProductivityRepository";
import CustomLoader from "../../components/CustomLoader";

const SectorProductivity: React.FC = () => {

    const [list, setList] = useState<ISectorProductivityMonth[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<ISectorProductivityParams>({ dataInicial: "", dataFinal: "" });

    const totalGeral = list.reduce((a, b) => a + b.quantidade, 0);

    const setColor = (quantidade: number) => {
        if (quantidade >= 50) {
            return <Label color="green">
                {quantidade}
            </Label>
        }
        else {
            return quantidade;
        }
    }

    const load = async () => {

        setLoading(true);
        try {

            const response = await sectorProductivityRepository.PartialMonth({
                dataInicial: state.dataInicial,
                dataFinal: state.dataFinal
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    const onChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: InputProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Qtd",
            content: (x: ISectorProductivityMonth) => setColor(x.quantidade),
            textAlign: "center",
            width: 1
        },
        {
            header: "Gerente de Setor",
            content: (x: ISectorProductivityMonth) => x.gerente,
            textAlign: "left",
            width: 14
        }
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content="Kits Novos" icon="user plus" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Data Inicial"
                                                labelPosition="left"
                                                name="dataInicial"
                                                type="date"
                                                value={state.dataInicial}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Data Final"
                                                labelPosition="left"
                                                name="dataFinal"
                                                type="date"
                                                value={state.dataFinal}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    disabled={
                                        (state.dataInicial !== "" && state.dataFinal !== "") ? false : true
                                    }
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Pesquisar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment raised color="teal">
                                    <Statistic.Group widths="1">
                                        <Statistic color="teal">
                                            <Statistic.Value>{totalGeral}</Statistic.Value>
                                            <Statistic.Label content="Total geral"></Statistic.Label>
                                        </Statistic>
                                    </Statistic.Group>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default SectorProductivity;
